module.exports = __webpack_public_path__ + "static/media/Windmill.a9aaf59d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Windmill.jpg
// module id = 991
// module chunks = 0